var map = {
	"./付款弹窗背景.png": "eb11",
	"./内置多种模版.png": "bef2",
	"./在线生成统计报表.png": "e8dd",
	"./智能获取员工信息.png": "a644",
	"./模版自动更新.png": "80ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c86e";